import { ProductMedia } from './types/Product'

export const CATEGORY_MEDIA_TYPES = {
  ICON: 'icon',
  DEFAULT: 'default',
} as const

export type CategoryMediaType = typeof CATEGORY_MEDIA_TYPES[keyof typeof CATEGORY_MEDIA_TYPES]

export interface CategoryIconData {
  url: string
  preview: string
  type: CategoryMediaType
  label: string
}

// Gets category icon with fallback logic: icon → default → null
export const getCategoryIcon = (media?: ProductMedia[], type?: CategoryMediaType) => {
  if (!media || media.length === 0) {
    return null
  }

  if (type) {
    return media.find((item) => item['media.type'] === type)
  }

  // Try icon type first
  const iconMedia = media.find((item) => item['media.type'] === CATEGORY_MEDIA_TYPES.ICON)
  if (iconMedia) {
    return iconMedia
  }

  // Fallback to default type
  return media.find((item) => item['media.type'] === CATEGORY_MEDIA_TYPES.DEFAULT)
}

export const hasCategoryIcon = (media?: ProductMedia[]): boolean => {
  if (!media || media.length === 0) {
    return false
  }

  return media.some((item) => item['media.type'] === CATEGORY_MEDIA_TYPES.ICON
    && item['media.url'])
}

export const getMediaTypePriority = (mediaType: string): number => {
  switch (mediaType) {
    case CATEGORY_MEDIA_TYPES.ICON:
      return 2
    case CATEGORY_MEDIA_TYPES.DEFAULT:
      return 1
    default:
      return 0
  }
}
